module.exports = __webpack_public_path__ + "487133c531.jpg";